// extracted by mini-css-extract-plugin
module.exports = {"iconCard":"AdminShortcuts_iconCard___N_Qr","label":"AdminShortcuts_label__TroFi"};